import {
    Component,
    Host,
    h,
    State,
    Element,
    Prop,
    Listen,
    Watch,
} from "@stencil/core";
import { isCookieConsentAccepted } from "../../utils/cookieConsent";

/**
 * @slot (default) - for the items to be shown if the cookies have not been accepted
 */

@Component({
    tag: "ux-iws-social-media-wall",
    styleUrl: "social-media-wall.scss",
})
export class SocialMediaWall {
    private baseClass = "ux-iws-social-media-wall";
    private Wallsio: any = null;
    private loadingSpinner: HTMLDivElement;

    @Element() element: HTMLUxIwsSocialMediaWallElement;

    /** text to be shown to load more post */
    @Prop() loadMoreText: string = "Load more";
    /** text to be shown when there are not more post to load */
    @Prop() noMorePostsText: string = "There are no more posts to be shown";
    /** specific country identifier of the wall */
    @Prop() wallIdentifier: string = "";

    @State() cookiesAccepted: boolean = false;
    @State() showBottomCTA: boolean = false;
    @State() showNoMorePosts: boolean = false;
    @State() postsLoading: boolean = false;

    // checks if cookies have already been accepted
    componentWillLoad() {
        isCookieConsentAccepted().then(() => (this.cookiesAccepted = true));
    }

    //Support for the old cookie layer
    @Listen("uxLegacyCookiesAccepted", { target: "window" })
    handleCookiesAcceptedLegacy() {
        this.cookiesAccepted = true;
    }

    // Support for the new cookie layer
    @Listen("uxCookieSettings", { target: "window" })
    handleCookiesAccepted(event) {
        const settings = event.detail;
        if (settings.optional === true) {
            this.cookiesAccepted = true;
        }
    }

    @Listen("WallsioNoMorePosts", { target: "document" })
    handleNoMorePosts() {
        setTimeout(() => {
            this.showNoMorePosts = true;
        }, 2000);
    }

    componentDidLoad() {
        const postLoadedCheck = setInterval(() => {
            if (this.showBottomCTA === true) {
                clearInterval(postLoadedCheck);
                return;
            }
            const rects = this.element.getBoundingClientRect();
            if (rects.height > 700) this.showBottomCTA = true;
        }, 1000);
    }

    private loadMorePosts = () => {
        if (this.Wallsio === null) this.Wallsio = (window as any).Wallsio;
        this.postsLoading = true;
        this.Wallsio!.loadMorePosts();
    };

    @Watch("postsLoading")
    handleLoadingComplete() {
        const checkSpinnerPosition = setInterval(() => {
            if (this.postsLoading === false) {
                clearInterval(checkSpinnerPosition);
                return;
            }
            const top = this.loadingSpinner.getBoundingClientRect().top;
            if (top > window.innerHeight) this.postsLoading = false;
        }, 100);
    }

    render() {
        const {
            baseClass,
            cookiesAccepted,
            wallIdentifier,
            showBottomCTA,
            showNoMorePosts,
            postsLoading,
        } = this;
        return (
            <Host class={baseClass}>
                <div
                    class={{
                        [`${baseClass}__placeholder`]: true,
                        [`${baseClass}__placeholder--hidden`]: cookiesAccepted,
                    }}
                >
                    <slot />
                </div>
                {cookiesAccepted && (
                    <div class={`${baseClass}__content`}>
                        <script
                            async
                            src="https://walls.io/js/wallsio-widget-1.2.js"
                            data-wallurl={`https://my.walls.io/${wallIdentifier}?nobackground=1&show_header=0`}
                            data-title="TRUMPF Deutschland"
                            data-width="100%"
                            data-autoheight="1"
                            data-lazyload="1"
                        ></script>
                        {showBottomCTA && (
                            <div class={`${baseClass}__cta-wrapper`}>
                                {!showNoMorePosts ? (
                                    <div>
                                        {postsLoading && (
                                            <div
                                                class={`${baseClass}__loading`}
                                                ref={(el) =>
                                                    (this.loadingSpinner = el)
                                                }
                                            >
                                                <ux-loader variant="spinner"></ux-loader>
                                            </div>
                                        )}
                                        <ux-button onClick={this.loadMorePosts}>
                                            {this.loadMoreText}
                                        </ux-button>
                                    </div>
                                ) : (
                                    <p class="ux-text-normal">
                                        {this.noMorePostsText}
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </Host>
        );
    }
}
